module.exports = __webpack_public_path__ + "img/businessmen-stationed.dc268173.svg";